package uz.ferro.erp.util

external fun encodeURIComponent(text: String): String

fun String.encodeUri(): String = encodeURIComponent(this)